import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { namesList as counterpartiesList } from "sources/books/cargoOwners";

class HiredCarsList extends BookIndex {
    state = { tableColumns: this.tableColumns };

    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Гос. номер",
                accessor: "number",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.hiredCarsShow(id)}>{value}</Link>,
            },
            {
                Header: "Тип",
                accessor: "typeId",
                filterable: false,
                Cell: ({ value }) => enumLabel(this.props.enums.carType, value, ""),
            },
            {
                Header: "Марка",
                accessor: "brandTypeId",
                filterable: false,
                Cell: ({ value }) => enumLabel(this.props.enums.carBrandType, value, ""),
            },
            {
                Header: "Перевозчик(и)",
                accessor: "counterparties",
                id: "counterpartyIds",
                sortable: false,
                filterable: true,
                filterType: "arrayContains",
                isMulti: true,
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            url: counterpartiesList,
                            inputProps: { name: "counterpartyIds" },
                            propName: "name",
                            components: { ValueContainer },
                        }}
                    />
                ),
                Cell: ({ value }) =>
                    value?.length
                        ? value.map((counterparty) => (
                              <a
                                  className="d-block"
                                  href={paths.cargoOwnersShow(counterparty.id)}
                                  key={counterparty.id}
                                  target="_blank"
                                  rel="noreferrer"
                              >
                                  {counterparty.name}
                              </a>
                          ))
                        : null,
                CSVExport: ({ value }) =>
                    value?.length ? value.map((counterparty) => counterparty.name).join("; ") : "",
            },
            isDeletedColumn(this.restore, this.props.canEditBooks),
        ];
    }

    renderCreateButton = () => {
        const { modal, mergeParams, canCreateBooks } = this.props;
        if (!canCreateBooks) {
            return null;
        }
        return (
            <a
                className="btn btn-brand btn-sm"
                onClick={() =>
                    modal({
                        name: "hiredCarForm",
                        title: "Создание наёмного ТС",
                        windowMod: "sm",
                        mergeParams,
                    })
                }
            >
                Создать
            </a>
        );
    };

    renderListComponent = () => (
        <>
            <div className="table-tabs mb-2">
                <NavLink to={paths.hiredCars} className="table-tabs__item" activeClassName="table-tabs__item--active">
                    Машины
                </NavLink>
                <NavLink
                    to={paths.hiredTrailers}
                    className="table-tabs__item"
                    activeClassName="table-tabs__item--active"
                >
                    Прицепы
                </NavLink>
                <NavLink
                    to={paths.hiredDrivers}
                    className="table-tabs__item"
                    activeClassName="table-tabs__item--active"
                >
                    Водители
                </NavLink>
            </div>
            <SharedReactTable {...this.props} columns={this.state.tableColumns} />
        </>
    );
}

export default tableContainer(HiredCarsList, "hired-cars");
